import Echo from 'laravel-echo'
import { URL_ECHO } from '@/utils/constants'
import localStorage from './localstorage'
window.io = require('socket.io-client')

export default new Echo({
  broadcaster: 'socket.io',
  host: `${URL_ECHO}`,
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.get('token')}`,
      Context: 'user',
     },
  },
})
